import { createApiSlice } from "@common";
import {
  CRUD_PROSPECT_QUALIFICATION,
  GET_PROSPECT_QUALIFICATION_BY_PROSPECT_ID
} from "@routes";

const apiConfig = [
  {
    name: "addProspectQualification",
    method: "post",
    url: CRUD_PROSPECT_QUALIFICATION,
    stateKey: "message",
  },
  {
    name: "getProspectQualificationByProspectId",
    method: "get",
    url: GET_PROSPECT_QUALIFICATION_BY_PROSPECT_ID,
    stateKey: "details",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "prospectQualification",
  apiConfig,
  customReducers
);
const prospectQualificationSlice = slice;

export default prospectQualificationSlice.reducer;

export const {
  addProspectQualification,
  getProspectQualificationByProspectId,
} = thunks;

export const { rowSelect } = actions;
